import { Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import React, { ReactElement, useEffect, useState } from 'react';
import { VALIDATE_MESSAGES } from '../../../../../../shared/constants/commonConstants';
import { useSetDetailInForm } from '../../../../../../shared/hooks/setDetailInForm/useSetDetailInForm';
import { RootState } from '../../../../../../store';
import { setsubmitDisabled } from '../../../../../../store/actions/newAdmissionAction';
import { AdmissionContext } from '../../AdmissionContext';
import MultiPayerClaimDetails from '../cards/MultiPayerClaimDetails/MultiPayerClaimDetails';
import { useDispatch, useSelector } from 'react-redux';

interface IMultipayerWrapper {
  form: FormInstance;
  buddhimedForm?: FormInstance;
  className?: string;
  setIsSubmitDisabled?: any;
  isEditPage?: boolean;
}
const MultipayerFormWrapper = (props: IMultipayerWrapper): ReactElement => {
  const { form, className = '', buddhimedForm, isEditPage } = props;
  const claimDetailBackup = useSetDetailInForm(form, isEditPage);
  const { admissionFormVal, isMinimize } = useSelector((state: RootState): any => state?.newAdmission);
  const [isValidated, setIsValidated] = useState({});
  const [formItemRequired, setIsFormItemsRequired] = useState({});
  const {claimDetails} = useSelector((state: RootState): any => state?.admissionDetails);
  const dispatch = useDispatch();
  const { payerList: { formControlConfig }} = useSelector((state: RootState): RootState =>
    state);

  useEffect((): any => {
    if (Object.keys(admissionFormVal?.customerDetail)?.length > 0) {
      const newAdmissionFormData = {
        ...admissionFormVal?.customerDetail,
        ...admissionFormVal?.admissionFormVal,
      };
      form.setFieldsValue(newAdmissionFormData);
    }
  }, [admissionFormVal]);

  useEffect((): any => {
    checkRequiredFormFields();  // checking the required fields on load , change of claimDetails
  }, [claimDetails, isMinimize]);

  useEffect((): any => {
    const formKeys = Object.keys(form.getFieldsValue());  // validatng the fields when required fields get changed
    formKeys.map((ele: any): any => {
      const formValues = form?.getFieldValue([ele]);
      checkValidated(ele, formValues);
    });

  }, [formItemRequired]);

  useEffect((): any => {
    if (Object.keys(formItemRequired)?.length > 0) {
    const allKeysPresentAndTrue = Object.entries(formItemRequired).every(([key]: any): boolean => {
      return isValidated.hasOwnProperty(key) && isValidated[key] === true;
    });
    if (allKeysPresentAndTrue) {
      setTimeout((): any => {
        form?.validateFields().then((): any => {
        dispatch(setsubmitDisabled(false));
      }).catch((): any => {
        dispatch(setsubmitDisabled(true));
      });
    }, 10);
    } else {
      dispatch(setsubmitDisabled(!allKeysPresentAndTrue));
    }
  }
// whenver the fields are changed, the fields are validated and the button is disabled according to that
  }, [isValidated]);

  useEffect((): any => {
    checkRequiredFormFields();

  }, [form.getFieldValue(['stayLength'])]);

const checkRequiredFormFields = (): void => {
  const formKeys = Object.keys(form.getFieldsValue());
    const requiredArr = {}; // function to check what are the required fields in the form and check if they are filled or not
    formKeys.map(async (ele: any): Promise<any> => {
      const requiredProp = await form.getFieldInstance(ele)?.props?.required;
      const isFieldRequired = requiredProp === undefined ? formControlConfig[ele]?.required : requiredProp;
      if (isFieldRequired) {
        requiredArr[ele] = isFieldRequired;
      }
    });
  setTimeout((): any => {
    setIsFormItemsRequired(requiredArr);
  }, 100);

};
  const checkValidated = (formKey: any, formValues: any): any => {
    if (formItemRequired[formKey] === true) {
      setIsValidated((prevIsValidated: any): any => ({
        ...prevIsValidated,
        [formKey]: hasValue(formValues),
      }));
    }
  };
  const hasValue = (value: any): boolean =>
    value !== null &&
    value !== undefined &&
    value !== '' &&
    (!Array.isArray(value) || (value?.length > 0 && value?.some((v: any): any => ((typeof v === 'string') &&  v?.trim() !== ''))));

  const onChangeForm = async (): Promise<any> => {
    setTimeout(async (): Promise<any> => {
      await checkRequiredFormFields();
    }, 1000);
  };
  return (
    <Form
      layout="vertical"
      form={form}
      validateMessages={VALIDATE_MESSAGES}
      requiredMark="optional"
      scrollToFirstError={true}
      onValuesChange = {onChangeForm}  // submit button is slow (IPP-4814)
    >
      <div className={`sticky-panel scrollbar ${className}`}>
        <AdmissionContext.Provider value={{
          claimDetailBackup,
          form,
          buddhimedForm,
        }}>
          <MultiPayerClaimDetails form={form} isLoading={false}/>
        </AdmissionContext.Provider>
      </div>
    </Form>
  );
};
export default MultipayerFormWrapper;
